// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__26MdK","title":"ClientCherryInfo_title__1C3na","itemText":"ClientCherryInfo_itemText__3vyJP"};